// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kb-0";
export var assigneeDetails = "_kb-1";
export var assigneeInfo = "_kb-2";
export var dropdownContainer = "_kb-4";
export var dropdownImage = "_kb-5";
export var editAssigneeInfo = "_kb-3";
export var editAssigneeModalContainer = "_kb-6";
export var hidden = "_kb-8";
export var input = "_kb-7";